import Vue        from 'vue'
import App        from './App.vue'
import router     from './router/index.js'
import store      from './vuex/store.js'
import VueTheMask from 'vue-the-mask'

import faIcon  	  from './assets/js/font-awesome.js'
import Loading 	  from './components/Tools/Loading'
import Alert 	  from './components/Modal/Alert'
import Confirm 	  from './components/Modal/Confirm'
import LoadScript from 'vue-plugin-load-script'

//	COMPONENTES GLOBAIS
Vue.component('Loading', Loading)
Vue.component('modal-alert', Alert)
Vue.component('modal-confirm', Confirm)

Vue.config.productionTip = false

Vue.use(LoadScript)
Vue.use(VueTheMask)
Vue.use(require('vue-moment'))

Vue.filter("brl_real", payload => {
	payload = Number(payload)

	if ( !isNaN(payload) )
		return payload.toLocaleString("pt-BR", {
			style: "currency",
			currency: "BRL"
		})

	else return ""
})

Vue.use(require('vue-pusher'), {
    api_key: '30898178000162',
    options: {
        cluster: 'ap1',
		encrypted: false,
		 //wsHost: "localhost:8012",
		 //httpPath: "/broadcast"
    }
})

new Vue({
	router, store, render: h => h(App),
}).$mount('#Application')
